import './CommonActivationPage.css';
import React from 'react';

export default function CommonActivationPage({ className = '', children }) {
  return <div className={`CommonActivationPage ${className}`}>{children}</div>;
}
